<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import reassessmentImage from '/images/reassessment-modal-img.svg'

const props = defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  close: []
  neverShowAgain: []
  seeLater: []
  goToReassessment: []
}>()

const { t } = useI18n()

function handleNeverShowAgain() {
  localStorage.setItem('reassessment_modal_never_show', 'true')
  emit('neverShowAgain')
}

function handleSeeLater() {
  emit('seeLater')
}

function handleGoToReassessment() {
  localStorage.setItem('reassessment_modal_viewed', 'true')
  emit('goToReassessment')
}

function handleClose() {
  emit('close')
}
</script>

<template>
  <SolModal
    id="reassessment-modal"
    :is-open="props.isOpen"
    :title="t('reassessment.modal.title')"
    :size="{
      desktop: 'medium',
      mobile: 'bottom-sheet',
    }"
    :show-action-primary="false"
    @close="handleClose"
  >
    <div class="flex justify-center flex-col items-center gap-6">
      <!-- image -->
      <img
        class="w-48 h-auto"
        :src="reassessmentImage"
        alt="Ilustração de repescagem de clientes"
      >

      <!-- content -->
      <div class="text-center">
        <p class="leading-6 fonts-body-large-regular">
          {{ t('reassessment.modal.description.prefix') }}<span class="fonts-body-large-bold text-brand-secondary-dark">{{ t('reassessment.modal.description.highlight') }}</span>{{ t('reassessment.modal.description.suffix') }}
        </p>
      </div>

      <!-- Custom buttons -->
      <div class="flex w-full gap-3">
        <SolButton
          id="see-later-btn"
          variant="secondary"
          size="large"
          class="w-full"
          @click="handleSeeLater"
        >
          {{ t('reassessment.modal.seeLater') }}
        </SolButton>
        <SolButton
          id="go-to-reassessment-btn"
          variant="primary"
          size="large"
          class="w-full"
          @click="handleGoToReassessment"
        >
          {{ t('reassessment.modal.button') }}
        </SolButton>
      </div>
      <div>
        <SolButton
          id="never-show-again-btn"
          variant="tertiary"
          size="small"
          class="w-full"
          @click="handleNeverShowAgain"
        >
          {{ t('reassessment.modal.neverShowAgain') }}
        </SolButton>
      </div>
    </div>
  </SolModal>
</template>
